"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var NoData = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #e5ebf0;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  margin: 1rem 0 1rem 0;\n  font-size: 15px;\n"], ["\n  background: #e5ebf0;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  margin: 1rem 0 1rem 0;\n  font-size: 15px;\n"])));
var NoDataLabel = function () { return react_1.default.createElement(NoData, null, "Nejsou evidov\u00E1na \u017E\u00E1dn\u00E1 data"); };
exports.default = NoDataLabel;
var templateObject_1;
